import { render, staticRenderFns } from "./buttonComponent.vue?vue&type=template&id=2a0dbfdb"
import script from "./buttonComponent.vue?vue&type=script&lang=js"
export * from "./buttonComponent.vue?vue&type=script&lang=js"
import style0 from "./buttonComponent.vue?vue&type=style&index=0&id=2a0dbfdb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports